import { HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import CustomField, { CustomFieldDto } from "./CustomField"

class CustomFieldService {
    static httpClient = new HttpClient<CustomField, CustomFieldDto>(CustomField)

    static async getAll(): Promise<CustomField[] | HttpError> {
        const res = await this.httpClient.get("/custom-field-definitions")
        if (isError(res)) {
            return res as HttpError
        }
        return res as CustomField[]
    }

    static async getAvailableFor(objectType: string) {
        const res = await this.httpClient.get("/custom-field-definitions")
        if (isError(res) || !Array.isArray(res)) {
            return []
        }
        return res.filter(x => x.isAvailableForObjectType(objectType))
    }

    static async getAvailableByObjectAndTypes(objects: string[], types: string[]) {
        const res = await this.httpClient.get("/custom-field-definitions")
        if (isError(res) || !Array.isArray(res)) {
            return []
        }
        return res.filter(cf => cf.isAvailable([...objects]) && types.includes(cf.getFieldType())) as CustomField[]
    }
}

export default CustomFieldService


// WEBPACK FOOTER //
// ./src/state/custom-fields/CustomFieldService.ts